import React from 'react';
import './checkboxes.css';
import { Label } from '@nooz-optics/nooz-components-lib';
import clsx from 'clsx';

const returnCheckboxSize = (size: string): string => {
  switch (size) {
    case 'base':
      return 'w-5 h-5';
    case 'lg':
      return 'w-8 h-8';
    default:
      return '';
  }
};

export const Checkbox = ({
  value,
  label,
  size = 'base',
  name,
  register,
  color,
}) => {
  const hover =
    'hover:ring-2 hover:ring-offset-1 hover:ring-gray-500 hover:ring-opacity-25';

  return (
    <div className='flex items-center my-1'>
      <div className='flex items-center'>
        {/* TODO should use Radio lib component */}
        <input
          id={value}
          name={name}
          value={value}
          type='checkbox'
          style={{ background: color?.hex }}
          className={clsx(
            returnCheckboxSize(size),
            'cursor-pointer text-primary border-gray-300 rounded-full focus:ring-primary',
            hover
          )}
          {...(register && register(name))}
        />
      </div>
      {label && (
        <label
          for={value}
          className='ml-4 cursor-pointer hover:underline flex-1 text-sm'>
          <Label text={label?.text} />
        </label>
      )}
    </div>
  );
};

export const Checkboxes = ({ values, key, name, register, label }) => (
  <div
    key={key}
    className='relative flex flex-col justify-center checked:bg-blue-600'>
    <Label {...label} />
    {values.map((inputValue) => (
      <Checkbox
        {...inputValue}
        register={register}
        name={name}
      />
    ))}
  </div>
);
